module.exports = __webpack_public_path__ + "static/media/lodash.bd8a37fb.svg";